var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.60005C0 2.61005 0.81 1.80005 1.8 1.80005H8.1L9.9 3.60005H16.2C16.6774 3.60005 17.1352 3.78969 17.4728 4.12726C17.8104 4.46482 18 4.92266 18 5.40005V14.4C18 14.8774 17.8104 15.3353 17.4728 15.6728C17.1352 16.0104 16.6774 16.2 16.2 16.2H1.8C1.32261 16.2 0.864773 16.0104 0.527208 15.6728C0.189642 15.3353 0 14.8774 0 14.4V3.60005ZM1.8 5.40005V14.4H16.2V5.40005H1.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.130ef04e989ed7798c6eb554a003041a.svg";
export { ForwardRef as ReactComponent };